import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {PostRequestUploadDoc} from 'domain/usecases/others/facial-biometric';
import {RemoteFacialBiometricPostUploadDoc} from 'data/usecases/others/facial-biometric/request';
import {FacialBiometricEndpoints} from 'main/factories/usecases/endpoints';

export const makePostRequestFacialBiometricUploadDoc = (): PostRequestUploadDoc =>
	new RemoteFacialBiometricPostUploadDoc(
		makeBFFApiUrl(FacialBiometricEndpoints.photoDoc),
		makeAuthorizeHttpClientDecorator(),
	);
